import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const ru: Translations = {
  // Common
  common: {
    appName: appName,
    loading: 'Загрузка...',
    save: 'Сохранить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    delete: 'Удалить',
    edit: 'Редактировать',
    back: 'Назад',
    search: 'Поиск',
    noResults: 'Результаты не найдены',
    error: 'Произошла ошибка',
    success: 'Успешно',
  },

  // Header
  header: {
    searchPlaceholder: 'Поиск новостей, тем, хэштегов...',
    searchPlaceholderMobile: 'Поиск...',
    home: 'Главная',
    hotgirl: 'Хотгёрл',
    coser: 'Косплей',
    model: 'Модель',
    upload: 'Загрузить',
    notifications: 'Уведомления',
    login: 'Войти',
    register: 'Регистрация',
  },

  // Footer
  footer: {
    tagline: 'Лучшая платформа для публикации фото косплееров, хотгёрлз и моделей.',
    copyright: `© {year} ${appName}. Все права защищены.`,
    sections: {
      explore: 'Обзор',
      account: 'Аккаунт',
      support: 'Поддержка',
    },
    links: {
      home: 'Главная',
      hotgirl: 'Хотгёрл',
      coser: 'Косплей',
      model: 'Модель',
      aoDai: 'Ао Зай',
      login: 'Войти',
      register: 'Регистрация',
      upload: 'Загрузить фото',
      dashboard: 'Панель управления',
      terms: 'Условия использования',
      privacy: 'Политика конфиденциальности',
      report: 'Сообщить о нарушении',
      contact: 'Связаться с нами',
    },
  },

  collections: {
    title: 'Коллекции',
    createAlbum: 'Создать альбом',
    saved: 'Сохранённые',
    noSaved: 'Нет сохранённых фото',
    noSavedHint: 'Перейти к просмотру фото →',
    removedSave: 'Удалено из сохранённых',
    createModalTitle: 'Создать новый альбом',
    albumNamePlaceholder: 'Название альбома...',
    cancel: 'Отмена',
    create: 'Создать',
    albumCreated: 'Альбом создан',
  },

  // Home page
  home: {
    title: 'Открывайте',
    titleHighlight: 'красоту',
    titleSuffix: 'жизни',
    subtitle: 'Тысячи фото косплееров, хотгёрлз и моделей обновляются каждый день',
    sortNewest: 'Новые',
    sortTrending: 'В тренде',
    sortPopular: 'Популярные',
    allCategories: 'Все',
    noMorePosts: 'Вы просмотрели все фото',
  },

  // Auth
  auth: {
    login: {
      title: 'Войдите, чтобы продолжить',
      continueWithGoogle: 'Продолжить с Google',
      orLoginWithEmail: 'или войдите по электронной почте',
      email: 'Электронная почта',
      password: 'Пароль',
      forgotPassword: 'Забыли пароль?',
      submitButton: 'Войти',
      loading: 'Вход...',
      noAccount: 'Нет аккаунта?',
      registerLink: 'Зарегистрироваться',
      errorCredentials: 'Неверная почта или пароль',
      successLogin: 'Вход выполнен успешно!',
    },
    register: {
      title: 'Создайте бесплатный аккаунт',
      displayName: 'Отображаемое имя',
      displayNamePlaceholder: 'Иван Иванов',
      email: 'Электронная почта',
      password: 'Пароль',
      passwordPlaceholder: 'Не менее 8 символов',
      confirmPassword: 'Подтвердите пароль',
      submitButton: 'Зарегистрироваться',
      loading: 'Создание аккаунта...',
      hasAccount: 'Уже есть аккаунт?',
      loginLink: 'Войти',
      errorPasswordMismatch: 'Пароли не совпадают',
      errorPasswordLength: 'Пароль должен содержать не менее 8 символов',
      errorGeneric: 'Ошибка регистрации',
      successRegister: 'Аккаунт успешно создан!',
      emailTaken: 'Эта почта уже используется',
      serverError: 'Ошибка сервера, попробуйте позже',
    },
    forgotPassword: {
      title: 'Забыли пароль',
      subtitle: 'Введите почту, и мы отправим ссылку для сброса',
      email: 'Электронная почта',
      submitButton: 'Отправить ссылку',
      backToLogin: 'Вернуться ко входу',
      sending: 'Отправка...',
      emailSent: 'Письмо отправлено!',
      checkEmail: 'Проверьте почту {email} — там ссылка для сброса пароля.',
      instructions: 'Введите почту, и мы отправим ссылку для сброса пароля.',
    },
  },

  // User menu
  userMenu: {
    dashboard: 'Панель управления',
    collections: 'Коллекции',
    settings: 'Настройки',
    logout: 'Выйти',
  },

  // Settings
  settings: {
    title: 'Настройки аккаунта',
    profile: {
      nav: 'Профиль',
      title: 'Информация профиля',
      displayName: 'Отображаемое имя',
      username: 'Имя пользователя',
      website: 'Сайт',
      bio: 'О себе',
      bioPlaceholder: 'Расскажите о себе...',
      changeAvatar: 'Изменить аватар',
      avatarHint: 'JPG, PNG, WebP до 5 МБ',
      saveButton: 'Сохранить изменения',
      saving: 'Сохранение...',
      savedSuccess: 'Изменения сохранены',
    },
    password: {
      nav: 'Пароль',
      title: 'Изменить пароль',
      fields: {
        currentPassword: 'Текущий пароль',
        newPassword: 'Новый пароль',
        confirm: 'Подтвердите новый пароль',
      },
      errors: {
        confirm: 'Новые пароли не совпадают',
        minLength: 'Пароль должен содержать не менее 8 символов',
      },
      success: 'Пароль успешно изменён!',
      saving: 'Сохранение...',
      submit: 'Изменить пароль',
    },
    notifications: {
      nav: 'Уведомления',
      title: 'Настройки уведомлений',
      options: {
        likes: 'Когда кто-то лайкает ваше фото',
        comments: 'Когда кто-то комментирует',
        replies: 'Когда кто-то отвечает на ваш комментарий',
        follows: 'Когда кто-то подписывается на вас',
        approved: 'Когда публикация одобрена',
        email_digest: 'Еженедельная сводка на почту',
        marketing: 'Рекламные и событийные уведомления',
      },
      saveSuccess: 'Настройки уведомлений сохранены',
      saving: 'Сохранение...',
      saveButton: 'Сохранить настройки',
    },
    security: {
      nav: 'Безопасность',
      twoFactorAuth: 'Двухфакторная аутентификация (2FA)',
      twoFactorAuthHint: 'Повысьте безопасность с помощью кода из приложения',
      comingSoon: 'Скоро',
      activeSessions: 'Активные сессии',
      currentBrowser: 'Текущий браузер',
      lastLogin: 'Последний вход',
      active: 'Активна',
      dangerZone: 'Опасная зона',
      deleteAccountHint: 'Удаление аккаунта навсегда уничтожит все ваши данные.',
      deleteAccount: 'Удалить аккаунт',
    },
  },

  // Post detail
  post: {
    likes: '{count} лайков',
    views: '{count} просмотров',
    shares: '{count} репостов',
    comments: '{count} комментариев',
    save: 'Сохранить',
    saved: 'Сохранено',
    share: 'Поделиться',
    linkCopied: 'Ссылка скопирована!',
    follow: 'Подписаться',
    following: 'Вы подписаны',
    relatedPosts: 'Похожие публикации',
    commentPlaceholder: 'Написать комментарий...',
    commentLoginPlaceholder: 'Войдите, чтобы комментировать...',
    commentSubmit: 'Отправить',
    commentSubmitting: 'Отправка...',
    noComments: 'Комментариев пока нет. Будьте первым!',
    savedToCollection: 'Добавлено в коллекцию',
    removedFromCollection: 'Удалено из коллекции',
    description: 'Описание',
    profileView: 'Перейти в профиль',
    replies: 'Ответы',
    unsaved: 'Удалено из сохранённого',
    liked: 'Понравилось',
    like: 'Нравится',
  },

  // Notifications
  notifications: {
    title: 'Уведомления',
    empty: 'Нет уведомлений',
    markAllRead: 'Отметить все как прочитанные',
    types: {
      like_post: 'лайкнул ваше фото',
      comment: 'прокомментировал ваше фото',
      reply: 'ответил на ваш комментарий',
      follow: 'подписался на вас',
      approve: 'ваша публикация одобрена',
      reject: 'ваша публикация отклонена',
      system: 'системное уведомление',
    },
  },

  // Search
  search: {
    title: 'Результаты поиска по запросу',
    result: 'Результаты',
    tryOtherKeywords: 'Попробуйте другие ключевые слова...',
    noResults: 'Ничего не найдено по запросу',
    placeholder: 'Поиск...',
    thisHashtag: 'фото с этим хештегом',
    results: 'результатов',
  },

  // Upload
  upload: {
    title: 'Загрузить фото',
    dragDrop: 'Перетащите или нажмите для выбора',
    supportedFormats: 'Поддерживаются JPG, PNG, WebP, GIF',
    submit: 'Опубликовать',
    submitting: 'Публикация...',
    titleField: 'Заголовок',
    cover: 'Обложка',
    titlePlaceholder: 'Введите привлекательный заголовок...',
    descriptionField: 'Описание',
    descriptionPlaceholder: 'Подробное описание фотосета...',
    hashtagsField: 'Хештеги',
    statusField: 'Статус',
    statusPublic: 'Публичный',
    statusPrivate: 'Приватный',
    statusDraft: 'Черновик',
    error: 'Ошибка загрузки',
    errorSelect: 'Выберите хотя бы 1 фото',
    errorTitle: 'Введите заголовок',
    photos: 'фото',
    uploading: 'Загрузка...',
  },

  // Not found
  notFound: {
    title: 'Страница не найдена',
    subtitle: 'Страница, которую вы ищете, не существует.',
    backHome: 'На главную',
  },

  liked: {
    title: 'Понравившиеся публикации',
    empty: 'Вы ещё не лайкали публикации.',
  },
  user: {
    unknown: 'Неизвестный',
  },
  globalError: {
    title: 'Произошла ошибка',
    subtitle: 'Извините за неудобства. Пожалуйста, попробуйте снова.',
    retry: 'Повторить',
  },
  username: {
    posts: 'Публикации',
    likes: 'Лайки',
    followers: 'Подписчики',
    following: 'Подписки',
    editProfile: 'Редактировать профиль',
    message: 'Сообщение',
    noPosts: 'Публикаций пока нет.',
    bio: 'Смотреть фото ',
    notFound: 'Пользователь не найден',
  },
  topic: {
    notFound: 'Тема не найдена',
    viewTitle: 'Просмотр темы ',
  },
  dashboard: {
    title: 'Панель управления',
    welcome: 'Привет',
    stats: {
      posts: 'Публикации',
      views: 'Просмотры',
      likes: 'Лайки',
      comments: 'Комментарии',
    },
  },
  adsblock: {
    title: 'Вы используете AdBlock',
    description: 'Пожалуйста, отключите AdBlock для просмотра качественных изображений и поддержки бесплатного сайта.',
    action: 'Я отключил — Перезагрузить',
    cancel: 'Пропустить',
  },
  pwa: {
    title: `становите ${appName} для лучшего опыта!`,
    iosSubtitle: 'Нажмите Поделиться → Добавить на главный экран',
    androidSubtitle: 'Получайте уведомления о новых наборах фотографий сразу после их выхода',
    installButton: 'Установить',
    disclaimer: 'Быстрая установка, без необходимости в магазине приложений.',
  },
  autotrans: {
    title: 'Автоматический перевод',
    translated: 'Перевод',
    origin: 'Исходный контент',
  },
  subscription: {
    title: 'Подписаться на уведомления',
    description: 'Получайте уведомления о новых наборах фотографий сразу после их выхода.',
    subscribeButton: 'Подписаться',
    unsubscribeButton: 'Отменить подписку',
    subscribed: 'Вы подписаны на уведомления.',
    unsubscribed: 'Вы отменили подписку на уведомления.',
    error: 'Произошла ошибка при обновлении вашей подписки. Пожалуйста, попробуйте снова.',
    success_tit: '🎉 Уведомления включены!',
    denied_tit: 'Уведомления отклонены',
    error_tit: 'Произошла ошибка',
    success_des: 'Вы будете получать уведомления, когда новый контент станет доступен.',
    denied_des: 'Вы можете повторно включить их в настройках вашего браузера.',
    error_des: 'Пожалуйста, попробуйте снова позже.',
    skip: 'Пропустить',
    processing: 'Обработка...',
    noti: 'Включить уведомления',
    rule: 'Показывать только уведомления о новом контенте.',
    notify_title: `Уведомления - ${appName}`,
    notify_body: "Новая галерея была выпущена. Проверьте это сейчас!",
  },
  contact: {
    title: 'Связаться с нами',
    subtitle: 'Мы будем рады услышать от вас! Пожалуйста, заполните форму ниже, и мы свяжемся с вами как можно скорее.',
    name: 'Имя',
    email: 'Электронная почта',
    subject: 'Тема',
    message: 'Сообщение',
    submitButton: 'Отправить сообщение',
    sending: 'Отправка...',
    successTitle: 'Сообщение отправлено!',
    successMessage: 'Спасибо за обращение. Мы свяжемся с вами в ближайшее время.',
    errorTitle: 'Произошла ошибка',
    errorMessage: 'Произошла ошибка при отправке вашего сообщения. Пожалуйста, попробуйте еще раз позже.',
    res_time_title: 'Время ответа',
    res_time: 'Мы обычно отвечаем в течение 1–3 рабочих дней.',
    report_content: 'Сообщить о содержимом',
    report_content_hint: 'Чтобы сообщить о посте или пользователе, используйте кнопку отчета непосредственно на содержимом или выберите «Сообщить о содержимом» выше.',
    value_default: 'Выберите тему',
    value_general: 'Общий запрос',
    value_report: 'Сообщить о содержимом',
    value_account: 'Проблема с аккаунтом',
    value_business: 'Бизнес / партнерство',
    value_feedback: 'Обратная связь и предложения',
    value_other: 'Другое'
  },
  // Language switcher
  language: {
    label: 'Язык',
    en: 'English',
    vi: 'Tiếng Việt',
    zh: '中文',
    ja: '日本語',
    ko: '한국어',
    ar: 'العربية',
    fr: 'Français',
    es: 'Español',
    ru: 'Русский',
    hi: 'हिन्दी',
    id: 'Indonesia',
    de: 'Deutsch',
    pt: 'Português',
    it: 'Italiano',
  },
} as const;

export default ru;